module.exports = __webpack_public_path__ + "img/binding_pc_tab_04.9df67809.png";